import UserManagement from "@/components/UserManagement";

const UsersPage = () => <UserManagement />;

export default UsersPage;
